if (!customElements.get("side-panel-links")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.links = this.querySelectorAll("button")),
        (this.drawer = document.getElementById("Product-Information-Drawer")),
        (this.buttons = this.drawer.querySelector(".side-panel-content--tabs")),
        (this.panels = this.drawer
          .querySelector(".side-panel-content--inner")
          ?.querySelectorAll(".side-panel-content--tab-panel")),
        (this.body = document.body);
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {}
    setupObservers() {
      this.links.forEach((e, t) => {
        e.addEventListener("click", (e) => {
        });
      });
    }
  }
  customElements.define("side-panel-links", e);
}
